// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/site-kpi/site-kpi.less
// module id = 4007
// module chunks = 0